<template>
  <div class="menu-box">
    <div class="top">
      <span class="word">EECA</span>
      <span class="title">电工行业高质量发展合格评定创新平台</span>
    </div>
    <div class="menu-rows">
      <div
        v-for="(item, index) in menuBox"
        class="row"
        :key="index">
        <div class="title-box" @click.stop="goPage(item)">
          <span class="title">{{item.title}}</span>
          <span v-if="item.childrens" class="angle-down"></span>

          <div v-if="item.childrens" class="childrens-box">
            <p v-for="(item1, index1) in item.childrens" class="item" :key="index1">
              <span class="name" :class="{active: item1.id === curSelected}"  @click.stop="goPage(item1)">{{item1.title}}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="user-box">
        <span
          v-if="$store.state.username"
          class="info" @click="goUsers"
        >
          <img :src="$images.man" alt="img" />
          {{$store.state.username}}
        </span>
        <span v-else class="info" @click="goLogin">您好，请登录</span>
        <!--<span class="register" @click="goRegister">注册</span>-->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'index',
  data () {
    return {
      curSelected: '',
      menuBox: [
        { id: '1', title: '首页', path: '/' },
        {
          title: '资讯公告',
          childrens: [
            { id: '2', title: '新闻资讯', path: '/consultation?type=2' },
            { id: '3', title: '政策法规', path: '/consultation?type=3' },
            { id: '4', title: '信息发布', path: '/consultation?type=4' }
          ]
        },
        {
          title: '合格评定目录',
          childrens: [
            { id: '5', title: '技术标准', path: '/catalog?type=5' },
            { id: '6', title: '认证规则', path: '/catalog?type=6' }
          ]
        },
        {
          title: '机构服务平台',
          childrens: [
            { id: '7', title: '机构管理', path: '/server?type=7' },
            { id: '8', title: '项目管理', path: '/server?type=8' },
            { id: '9', title: '证书/报告管理', path: '/server?type=9' }
          ]
        },
        {
          title: '关于我们',
          childrens: [
            { id: '10', title: '平台介绍', path: '/about?type=10' },
            { id: '11', title: '平台章程', path: '/about?type=11' },
            { id: '12', title: '组织架构', path: '/about?type=12' }
          ]
        }
      ]
    }
  },
  async created () {
    this.$EventBus.$on('onMenuSelected', vl => {
      this.curSelected = vl
    })
    // 如果未登录去获取一次用户信息
    if (!this.$store.state.username) {
      const users = await this.$https.getUser()
      this.$store.state.username = users.data.data.username
    }
  },
  methods: {
    goPage (item) {
      const { id, path, childrens } = item
      if (childrens) return

      this.curSelected = id
      this.$router.push({ path })
      this.$EventBus.$emit('onMenuSelectType', id)
    },
    goUsers () {
      this.$router.push({ path: '/users' })
    },
    goLogin () {
      this.$router.push({ path: '/login' })
    },
    goRegister () {
      this.$router.push({ path: '/register' })
    }
  }
}
</script>

<style lang="less" scoped>
.menu-box{
  display: flex;
  flex-direction: column;
  align-items: center;

  .top{
    width: 100%;
    height: 131px;
    display: flex;
    justify-content: center;
    align-items: center;

    .word{
      font-weight: 900;
      font-size: 38px;
      color: #004290;
      line-height: 28px;
    }
    .title{
      font-weight: normal;
      font-size: 32px;
      color: #004290;
      line-height: 22px;
      margin-left: 11px;
    }
  }
  .menu-rows{
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 63px;
    background: #006ED1;
    z-index: 10;
    min-width: 99vw;

    .row{
      display: flex;
      flex-direction: row;
      align-items: center;
      font-weight: bold;
      font-size: 18px;
      color: #FFFFFF;
      line-height: 63px;
      cursor: pointer;
      height: 100%;
      position: relative;

      .title-box{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        position: relative;
        padding: 0px 40px;
        min-width: 62px;
        user-select: none;

        &:hover{
          background: #004290;

          .childrens-box{
            display: block;
          }
        }

        .angle-down{
          width: 0px;
          height: 0px;
          border-top: 8px solid white;
          border-right: 7px solid transparent;
          border-left: 7px solid transparent;
          margin-left: 7px;
        }

        .childrens-box{
          display: none;
          position: absolute;
          top: 63px;
          left: 0px;
          width: calc(100% - 0px);
          background-color: white;
          border: 1px solid #006ED1;

          .item{
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            height: 52px;

            &:last-child{

              .name{
                border-bottom: none;
              }
            }

            .name{
              font-weight: 500;
              font-size: 18px;
              color: #666666;
              border-bottom: 1px solid #C1C1C1;
              line-height: 52px;

              &.active,
              &:hover{
                color: #006ED1;
              }
            }
          }
        }
      }
    }

    .user-box{
      width: 300px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;

      .info{
        display: flex;
        flex-direction: row;
        align-items: center;
        font-weight: bold;
        font-size: 16px;
        color: #FFFFFF;
        line-height: 22px;
        cursor: pointer;

        img{
          margin-right: 18px;
        }
      }
      .register{
        font-weight: bold;
        font-size: 16px;
        color: #FFFFFF;
        line-height: 22px;
        margin-left: 25px;
        cursor: pointer;
      }
    }
  }
}
</style>
